import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Grid, Box, Typography, Button, Tooltip, CircularProgress } from '@mui/material';
import Cookies from "js-cookie";
import { convertToRS } from 'core/js/FormUtils';

import FieldView from 'core/components/layout/FieldView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

import { addAnonymousCartItemAPI } from 'pages/dashboard/LandingPageAPI';
import { refreshCart, setCartObj, setCartCount, setSelectedBottomMenu } from 'store/slice/EcomSlice';
import { setProductManageProductModal, setSelectedProductId, updateProductObj } from 'store/slice/DmpSlice';
import { setMessage } from 'store/slice/HeaderSlice';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import {
  Badge,

  IconButton,
  Popper,
  useMediaQuery
} from '@mui/material';
import { Padding } from '../../../../node_modules/@mui/icons-material/index';
import Rating from '@mui/material/Rating';

export default function ProductInfo({ obj }) {
  const dispatch = useDispatch();
  const [expand, setExpand] = useState(false);
  const [moreClicked, setMoreClicked] = useState(false);
  const { rolename } = useSelector((state) => state.headerslice.userprofileInfo);
  const [apiInProgress, setApiInProgress] = useState(false);
  const {cartitemList, refreshOrder, cart} = useSelector((state)=>state.ecomslice);
  const {initPartnershipModalOpen} = useSelector((state) => state.dmpslice.mlmuserDashboard);
  const {userprofileInfo} = useSelector((state)=>state.headerslice);

  useEffect(() => {
  }, [cartitemList,refreshOrder]);

  const getDescription = (description) => {
    if (moreClicked) return description;

    if (description.length > 45) {
      return description.substr(0, 44)
    } else
      return description;
  }
  const handleMoreClicked = () => {
    setMoreClicked(!moreClicked);
  }
  const addProductToCartSuccess = (apiResponse) => {
    Cookies.set("anonymousId", apiResponse.cartInfo.anonymousid);
    //Cookies.set("cartId",apiResponse.cartInfo.id);
    if (localStorage.getItem("JWT") === null)
      localStorage.setItem("JWT", apiResponse.jwt)
    dispatch(setCartObj(apiResponse.cartInfo));
    dispatch(setCartCount((cart?.cartCount || 0) + 1));
    dispatch(refreshCart());
    dispatch(setSelectedBottomMenu('CART'));
    dispatch(setMessage(`${obj.title} added to cart`));
    setApiInProgress(false);
  }
  const addProductToCartFailure = (errMsg) => {
    setApiInProgress(false);
    console.log('errMsg=>' + errMsg);
  }
  const addProductToCart = () => {
    setApiInProgress(true);
    addAnonymousCartItemAPI({
      "anonymousId": Cookies.get("anonymousId"),
      "productCartItemInfo": { "quantity": "1", "productid": obj.id }
    }, addProductToCartSuccess, addProductToCartFailure)
  }
  const getQuantity = (productId) =>{
    if (!cartitemList  || cartitemList.length===undefined) return 0;
    let index = cartitemList.map(cartItemObj=>cartItemObj.productid).indexOf(productId);
    if(index!==-1)  return cartitemList[index].quantity

    return 0;
  }
  const openProductDetails = (obj) =>{
    dispatch(updateProductObj(obj))
   dispatch(setProductManageProductModal(true));
  }
  const selectProduct = (obj) => {
    dispatch(setSelectedProductId(obj.id));
    
  }
  return (
    <Grid container direction="column" justifyContent="space-between" sx={{ width: '100%', padding:1 }} >
      <Grid item xs={12} lg={3} sx={{ backgroundColor: 'white' }}>
        <Grid container direction="column">
          {!moreClicked ?
            <Grid container  >
              <img  onClick={()=>openProductDetails(obj)} src={obj.imagepath} style={{ cursor:'pointer', backgroundColor: 'white', width: '100%', borderRadius:2, height: '100%', }} />
            </Grid>
            : <></>}
          <Grid item xs={12} lg={4} sx={{ paddingTop: 2, paddingBottom: 2 }}>
            <Typography variant="h4" color="primary.darker">{obj.title}</Typography>
            <Rating
              name="product-rating"
              value={4.5} // Assuming `obj.rating` contains the rating value
              precision={0.5} // Allows half-star ratings
              readOnly // Makes the rating non-editable
              sx={{ marginTop: 1 }} // Adds spacing between the title and the rating
            />
          </Grid>
          <Grid item lg={12} xs={12}>
            <Grid container justifyContent="space-between" sx={{ height: '100%', }}>
              {/* <Grid item >
                <Typography variant="h6" sx={{ fontWeight: 'light', fontSize: 14 }}>{getDescription(obj.description)}<Button onClick={() => handleMoreClicked()}>{moreClicked ? 'Back' : 'More'}</Button></Typography>
              </Grid> */}
              {rolename==='MLM_PARTNER' || rolename==='MLM_MEMBER' || rolename==='MLM_CUSTOMER'|| rolename==='OPS_CUSTOMER' || rolename==='OPS_ANONYMOUS'?
                <Grid container justifyContent="space-between" alignItems="center" sx={{ backgroundColor:'secondary.100', width:'100%', padding:1}}>
                {apiInProgress ? <CircularProgress /> : (
                  <>
                    {/* Price on the left */}
                    <Grid item sx={{ flexGrow: 1 }}>
                      {(userprofileInfo.rolename === 'MLM_PARTNER' || userprofileInfo.rolename === 'MLM_MEMBER') ? (
                        <>
                          <Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'line-through', mr: 1 }}>
                            {convertToRS(obj.price)}
                          </Typography>
                          <Typography variant="h5" color="primary.darker" sx={{ fontWeight: 'bold' }}>
                            {convertToRS(Math.round(obj.price * 0.8))}
                          </Typography>
                        </>
                      ) : (
                        <Typography variant="h5" color="primary.darker">{convertToRS(obj.price)}</Typography>
                      )}
                    </Grid>
                    {/* Cart icon with text */}
                    <Grid item>
                      {initPartnershipModalOpen ? (
                        <Button
                          variant="contained"
                          endIcon={
                            <Tooltip title="Add to Cart">
                              <ArrowForwardIcon sx={{ cursor: "pointer", color: 'white' }} />
                            </Tooltip>
                          }
                          sx={{
                            backgroundColor: 'primary.darker',
                            color: 'white',
                            '&:hover': {
                              backgroundColor: 'primary.dark',
                            },
                          }}
                          onClick={() => selectProduct(obj)}
                        >
                          Select
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          startIcon={<Badge
                            badgeContent={getQuantity(obj.id)}
                            sx={{
                              '& .MuiBadge-badge': {
                                backgroundColor: 'primary.dark',
                                color: 'white'
                              }
                            }}
                            color="secondary"
                          >
                            <Tooltip title="Add to Cart">
                              <AddShoppingCartIcon sx={{ cursor: "pointer", color: 'white' }} />
                            </Tooltip>
                          </Badge>}
                          sx={{
                            backgroundColor: 'primary.darker',
                            color: 'white',
                            '&:hover': {
                              backgroundColor: 'primary.dark',
                            },
                          }}
                          onClick={() => addProductToCart()}
                        >
                          Add to Cart
                        </Button>
                      )}
                    </Grid>
                  </>
                )}
              </Grid> :
                <Grid container lg={12} xs={12} justifyContent="flex-end" sx={{ width: '100%' }}>
                  <Typography sx={{ backgroundColor: 'primary.darker', color: 'white', padding: 1, borderRadius: 2 }}>{convertToRS(obj.price)}</Typography>
                </Grid>
              }
            </Grid>


          </Grid>

        </Grid>
      </Grid>
    </Grid>
  )
}
